const SUCCESS_BANNER_SELECTOR = ".success-banner";
const HIDE_DELAY_MS = 5000;

export function scheduleSuccessBannerHideTimer(
  container: HTMLElement | null | undefined,
  htmlContent: string | null | undefined
): ReturnType<typeof setTimeout> | null {
  if (!htmlContent?.includes("success-banner") || !container) {
    return null;
  }

  return setTimeout(() => {
    const banner = container.querySelector(SUCCESS_BANNER_SELECTOR) as HTMLElement | null;
    if (banner) {
      banner.style.display = "none";
    }
  }, HIDE_DELAY_MS);
}
